const v4 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topScriptTopicsTable: {
          ...state.options.tableViews.topScriptTopicsTable,
          "MA Rating": true,
        },
        topThumbTopicsTable: {
          ...state.options.tableViews.topThumbTopicsTable,
          "MA Rating": true,
        },
        topTitleTopicsTable: {
          ...state.options.tableViews.topTitleTopicsTable,
          "MA Rating": true,
        },
        topVideoTypesTable: {
          ...state.options.tableViews.topVideoTypesTable,
          "MA Rating": true,
        },
      },
    },
  };
};

export default v4;
